/**
 * Shared helpers for navigating to a demand's detail page, including the
 * "open in a new browser tab" affordances used by the Demand List rows and
 * the Demand Kanban cards (issue #838). Keeping these in one place means the
 * two views behave identically.
 */

/** Route path for a demand's detail page. */
export function demandDetailPath(id: number): string {
  return `/demand/${id}`
}

/** Open a demand's detail page in a new browser tab (no opener leak). */
export function openDemandInNewTab(id: number): void {
  window.open(demandDetailPath(id), '_blank', 'noopener,noreferrer')
}

/**
 * True when a click should open in a new tab instead of navigating in-app:
 * Ctrl-click (Windows/Linux) or Cmd-click (macOS), matching how browsers
 * treat a modifier-click on an anchor.
 */
export function isNewTabModifier(event: { ctrlKey?: boolean; metaKey?: boolean }): boolean {
  return Boolean(event.ctrlKey || event.metaKey)
}
